export default __webpack_public_path__ + "static/thegreatestshowman-146242151b8400e801fc9f1b4fc7e68f.png";